import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class SubCategoryDefaults extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'SubCategoryDefaults'
  // Define default properties here
  static instanceDefaults () {
    return {
      subCategoryId: null,
      frameworkCategoryId: null,
    }
  }
}
const servicePath = 'sub-categories-defaults'
const servicePlugin = makeServicePlugin({
  Model: SubCategoryDefaults,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
